import React, { Component } from 'react'
import { graphql, compose } from 'react-apollo'
import gql from 'graphql-tag'
import { withRouter } from 'react-router-dom'
// import _last from 'lodash/last'

import { Modal, Button, Card } from 'antd'
import { FacebookShareButton } from 'react-share'
import Lightbox from 'react-simple-lightbox'
import share from './share.png'

import '../Slip.css'

class Certificate extends Component {
  constructor(props) {
    super(props)
    this.state = {
      redirect: false,
    }
  }
  notFound() {
    Modal.warning({
      title: 'Bib is not found',
      content: 'Sorry your bib number is not found ',
    })
  }
  componentWillReceiveProps(nextProps) {
    // console.log('update work')
    const { findTime, loading } = nextProps.data
    // console.log(nextProps)
    // const time = _last(findTime)
    // console.log('time', time)
    if (!loading && !findTime/*  (!time || !time.gunTime) */) {
      this.notFound()
      this.props.history.replace(`/${nextProps.slug}`)
    }
  }

  /* componentDidUpdate(props, state) {
        console.log('update work')
        const { times } = this.props.data
        const time = _.last(times)||{}
        console.log('time', time)
        if(time && !time.gunTime) {
            this.notFound()
            this.props.history.push(`/${this.props.slug}`)
        }
    } */
  render() {
    // console.log('render work')
    if (!this.props.data.findTime) {
      return <Button type="primary" style={{ marginLeft: '48%', marginTop: '22%' }} shape="circle" loading />
    }
    const { findTime } = this.props.data
    // const time = _last(findTime)
    // const shareUrl = `https://storage.googleapis.com/s.cert.thai.run/${event.slug}/${this.props.match.params.bib}.jpg`
    // console.log(shareUrl)
    const title = '#ThaiRun'
    // console.log('time', time)
    if (findTime/*  && findTime.gunTime */) {
      return (

        <div className="head-image-ecer">
          <Card className="content-card-ecer">
            <Lightbox >
              <img src={findTime.link} alt={findTime.bib} className="head-image-ecer" />
            </Lightbox>

            <FacebookShareButton url={findTime.link} hashtag={title}>
              <img src={share} alt={findTime.bib} className="head-image-button" />
            </FacebookShareButton>
          </Card>
        </div>
      )
    }
    return null
  }
}

const CertificateQuery = gql`
    query querySlip($event: String, $bibNumber: Float, $slug: String) {
        findTime(record: {
            bibNumber: $bibNumber ,
            event: $event,
            eSlip: true,
          	slug: $slug
        }) {
            gunTime
            event
            email
            link
            _id
        }
    }
`

export default compose(
  graphql(CertificateQuery, {
    options: props => ({
      variables: {
        bibNumber: props.bib,
        event: props.event,
        slug: props.slug,
      },
    }),
  }),
  withRouter
)(Certificate)



// WEBPACK FOOTER //
// ./src/Slip/Component/Certificate.js